<template>
    <div>
        <div class="home" v-if="exam">
            <div class="logo-wrapper pt-4 pb-4 mb-4">
                <router-link :to="{ name: 'course', params: { course: course.id } }">
                    <img src="/img/logo.png" alt="kapitani.bg logo" class="logo">
                </router-link>

                <div class="course-title text-center" v-if="course">
                    <div class="container">
                        {{ course.title }}
                    </div>
                </div>
            </div>
            <div class="mb-5 container">
                <div class="text-center exam-result-emoji">
                    <lottie-player
                        :src="isExamPassed ? thumbsUp : thumbsDown"
                        :options="{ autoplay: true, width: '240px' }"
                    />
                </div>

                <p class="text-center" style="margin-bottom: 5px;" v-if="isExamPassed">
                    Изпитът е издържан успешно!
                </p>

                <p class="text-center" style="margin-bottom: 5px;" v-if="!isExamPassed">
                    Не успяхте да издържите изпита!
                </p>

                <p class="text-center" style="font-size: 1.3em">
                    Имате <strong>{{ totalCorrect }}</strong> от {{ totalQuestions }} (<strong>{{ percent }}%</strong>) верни отговора.
                </p>

                <div class="mt-4 mx-auto text-center">
                    <router-link :to="{ name: 'exam.question', params: { course: course.id, question: 1 } }" class="btn btn-block btn-lg btn-primary">
                        Преглед
                    </router-link>

                    <router-link :to="{ name: 'course', params: { course: course.id } }" class="btn btn-block btn-lg btn-light">
                        Към начало
                    </router-link>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import ExamBuilder from '../../services/ExamBuilder'
    import courses from '../../data/courses';

    export default {

        data() {
            return {
                exam: null,
                course: null,
                thumbsUp: require('../../assets/thumbs_up.json'),
                thumbsDown: require('../../assets/thumbs_down.json'),
            }
        },

        computed: {
            totalCorrect() {
                return this.exam ? this.exam.calculateTotalCorrectAnswers() : 0;
            },

            totalQuestions() {
                return this.questions.length;
            },

            questions() {
                return this.exam ? this.exam.questions : [];
            },

            percent() {
                return parseInt(this.totalCorrect / this.totalQuestions * 100);
            },

            isExamPassed() {
                return this.course.isPassed(this.totalCorrect);
            }
        },

        methods: {
            setCurrentCourse(id) {
                this.course = courses.find(course => parseInt(course.id, 10) === parseInt(id, 10))
            },

            loadExam(courseId) {
                this.setCurrentCourse(courseId);

                this.exam = ExamBuilder.load(this.course);

                if (!this.exam.isFinished()) {
                    this.$router.push({
                        name: 'exam.question',
                        params: {
                            course: this.course.id,
                            question: this.exam.currentQuestion,
                        }
                    })
                }
            },
        },

        beforeRouteEnter (to, from, next) {
            next(vm => vm.loadExam(to.params.course));
        },
    }
</script>